jQuery.fn.setFirstLogoCrossfade = function (speed, animSpeed) {
    jQuery(".logos_2", this).css("display", "none");
    let $this = $(this);
    jQuery(".logos_1", this)
        .fadeIn(animSpeed)
        .delay(speed)
        .fadeOut(animSpeed, function () {
            $this.setSecondLogoCrossfade(speed, animSpeed);
        });
};


jQuery.fn.setSecondLogoCrossfade = function (speed, animSpeed) {
    jQuery(".logos_1", this).css("display", "none");
    let $this = $(this);
    jQuery(".logos_2", this)
        .fadeIn(animSpeed)
        .delay(speed)
        .fadeOut(animSpeed, function () {
            $this.setFirstLogoCrossfade(speed, animSpeed);
        });
};

jQuery(document).ready(function ($) {
    $('.logos-container.module').each(function () {
        let speed = parseInt($('.crossfaders', this).data('crossfade-speed'));
        let animSpeed = parseInt($('.crossfaders', this).data('crossfade-anim-speed'));

        if (!$(this).hasClass('animation-off'))
            $(this).setFirstLogoCrossfade(speed, animSpeed);
    });
})